import { MENU_ROUTES } from '../modules/menu/menu.model';

/**
 * Whether a main-navigation destination — a footer tab or a side-menu row — reads
 * as current on `url`: on its own route and anything nested under it, ignoring
 * query and fragment. Pages reached from سایر light سایر even where their URL
 * prefix says otherwise (/orders/history → سایر, not سفارش‌ها).
 */
export function isMainNavActive(url: string, route: string): boolean {
	const path = url.split(/[?#]/)[0];
	const nestedIn = (base: string) => path === base || path.startsWith(`${base}/`);

	if (MENU_ROUTES.some(nestedIn)) {
		return route === '/menu';
	}
	return nestedIn(route);
}
